import { getCountries } from 'libphonenumber-js/core';
import libPhoneNumberMetadata from 'libphonenumber-js/max/metadata';
import { createViewConfig } from '@sail/engine';
const COUNTRIES = getCountries(libPhoneNumberMetadata);
export const PhoneNumberFieldConfig = createViewConfig({
    props: {},
    name: 'PhoneNumberField',
    flattens: true,
    defaults: {
        countryAllowlist: COUNTRIES,
        size: 'medium',
        defaultCountry: 'US'
    }
});

//# sourceMappingURL=PhoneNumberFieldConfig.js.map